var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilmSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 32H48C21.492 32 0 53.492 0 80V432C0 458.508 21.492 480 48 480H464C490.508 480 512 458.508 512 432V80C512 53.492 490.508 32 464 32ZM112 464H48C30.355 464 16 449.645 16 432V408H112V464ZM112 392H16V312H112V392ZM112 296H16V216H112V296ZM112 200H16V120H112V200ZM112 104H16V80C16 62.355 30.355 48 48 48H112V104ZM384 464H128V48H384V464ZM496 432C496 449.645 481.645 464 464 464H400V408H496V432ZM496 392H400V312H496V392ZM496 296H400V216H496V296ZM496 200H400V120H496V200ZM496 104H400V48H464C481.645 48 496 62.355 496 80V104Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilmSimple);
export default __webpack_public_path__ + "static/media/film-simple.8bfb762abd4f5503fa852912f583b92c.svg";
export { ForwardRef as ReactComponent };